import HiddenInput from "@/components/form/components/HiddenInput";
import { setErrorsToForm } from "@/utils/formUtils";
import { validations } from "@/utils/validationUtils";
import { Form, Input, Modal } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useUpdateSplitCommissions } from "../../../../../common/api/queries";
import { ModalSizes } from "../../../../../common/constants";
import { SplitCommission, UpdateSplitCommission } from "../../types";

type Props = {
  isOpen: boolean;
  commission?: SplitCommission;
  onCancel: () => void;
};

export const UpdateSplitCommissionModalForm = ({ isOpen, onCancel, commission }: Props) => {
  const { t } = useTranslation();

  const [form] = Form.useForm<UpdateSplitCommission>();

  useEffect(() => {
    if (isOpen && commission) {
      form.setFieldsValue({
        optimisticLockVersion: commission.optimisticLockVersion,
        paymentPeriod: commission.paymentPeriod,
      });
    }
  }, [isOpen, commission, form]);

  const updateSplitCommissions = useUpdateSplitCommissions();

  const handleFormSubmit = () => {
    form.validateFields().then((values) =>
      updateSplitCommissions.mutate(
        { id: commission?.id ?? "", object: values },
        {
          onSuccess: onCancel,
          onError: (error) => setErrorsToForm(form, "commissions.splitCommissions.attrs", error.violations),
        },
      ),
    );
  };

  return (
    <Modal
      width={ModalSizes.TINY}
      open={isOpen}
      title={t("commissions.splitCommissions.titles.update")}
      okText={t("common.save")}
      cancelText={t("common.cancel")}
      confirmLoading={updateSplitCommissions.isPending}
      afterClose={() => form.resetFields()}
      onOk={handleFormSubmit}
      onCancel={onCancel}
      mask={{ closable: false }}
    >
      <Form form={form} layout="vertical" name="updateSplitCommission">
        <HiddenInput name="optimisticLockVersion" />

        <Form.Item
          label={t("commissions.splitCommissions.attrs.paymentPeriod")}
          name="paymentPeriod"
          rules={[validations.notNull]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};
